import React, { useState } from 'react'
import MainLayout from '../../layouts/Main'

// import { useGetUserCampuses } from '../../../hooks/campuses';
import { useExportCertificateAwardsReportForSchool, useGetCertificateAwardsReportForSchool } from '../../../hooks/analytics';
import { useGetStudentOnboardingResponsesOptionsByField } from '../../../hooks/misc';

import BarChart from '../../sub_components/charts/BarChart';
import FilterTable from '../../sub_components/tables/FilterTable';
import ReportDatePicker from '../../sub_components/ReportDatePicker';
import ReportTablet from '../../sub_components/ReportTablet';

import { IColumnProps, IFilterableDataProps } from '../../../interfaces/tables';
import { StudentOnboardingResponseOptionsField } from '../../../interfaces';

import { getDateString } from '../../../helpers/utility';

const CertificateAwardsReport = () => {
    // let filterTableDataColumns__Campuses: IColumnProps[] = [
    //     { name: "ID", identifier: "id" },
    //     { name: "Campus", identifier: "name" },
    // ];
    let filterTableDataColumns__ProgramsOfStudy: IColumnProps[] = [
        { name: "Program of Study", identifier: "name" },
    ];
    let filterTableDataColumns__CertificateAwardsReport: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Full Name", identifier: "full_name" },
        { name: "Email", identifier: "email" },
        { name: "Status", identifier: "status" },
        { name: "Course", identifier: "course_name" },
        { name: "Completion Date", identifier: "completed_at" },
    ];

    // let filterTableData__Campuses: IFilterableDataProps[] = [];
    let filterTableData__ProgramsOfStudy: IFilterableDataProps[] = [];
    let filterTableData__CertificateAwardsReport: IFilterableDataProps[] = [];

    const [campusFilters, setCampusFilters] = useState<number[]>([]); // eslint-disable-line
    const [programsOfStudyFilters, setProgramsOfStudyFilters] = useState<number[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");

    const { data: programsOfStudy } = useGetStudentOnboardingResponsesOptionsByField(StudentOnboardingResponseOptionsField.PROGRAM_OF_STUDY);

    const programsOfStudyOptions = programsOfStudy?.map((program, index) => ({
        id: index,
        name: program,
    })) ?? [];

    const filterQuery = new URLSearchParams();
    filterQuery.set("start_date", startDate);
    filterQuery.set("end_date", endDate);
    campusFilters.forEach((id) => filterQuery.append("campus_ids", id.toString()));
    programsOfStudyFilters.forEach((id) => filterQuery.append("programs_of_study", programsOfStudyOptions[id].name));

    // const { data: campuses } = useGetUserCampuses();
    const { data: certificateAwardsReport } = useGetCertificateAwardsReportForSchool(filterQuery.toString());
    const { mutate: exportCertificateAwardsReportForSchool } = useExportCertificateAwardsReportForSchool();

    // if (campuses) {
    //     filterTableData__Campuses = campuses.map((campus) => ({
    //         id: campus.id,
    //         name: campus.name,
    //     }));
    // }

    if (programsOfStudy) {
        filterTableData__ProgramsOfStudy = programsOfStudyOptions.map((program) => ({
            id: program.id,
            name: program.name,
        }));
    }

    if (certificateAwardsReport) {
        filterTableData__CertificateAwardsReport = certificateAwardsReport.table_data.map((certificate) => ({
            id: certificate.id,
            full_name: certificate.full_name,
            email: certificate.email,
            status: certificate.status,
            course_name: certificate.course_name,
            completed_at: certificate.completed_at ? getDateString(certificate.completed_at) : '-'
        }));
    }

    const onExportCsv = () => {
        exportCertificateAwardsReportForSchool({
            payload: {
                filterQuery: filterQuery.toString(),
            }
        });
    }

    return (
        <MainLayout>
            <div className='immersion__careers_report'>
                <div className='immersion__careers_report__header'>
                    <div className='immersion__careers_report__header__content'>
                        <h2 className='immersion__careers_report__header__content__title'>Certificate Awards Report</h2>
                        <p className='immersion__careers_report__header__content__description'>
                            This slide gives an overview of certificate awards completed by students.
                        </p>
                    </div>
                    <div className='immersion__careers_report__header__actions'>
                        <button className='immersion__btn immersion__btn__primary immersion__careers_report__header__actions__button' onClick={onExportCsv}>Export CSV</button>
                    </div>
                </div>
                <div className='immersion__careers_report__chart_body'>
                    <div className='immersion__careers_report__chart__row'>
                        {/* {campuses?.length
                            ? <FilterTable
                                columns={filterTableDataColumns__Campuses}
                                data={filterTableData__Campuses}
                                filters={campusFilters}
                                setFilters={setCampusFilters}
                                enableFilters={true}
                            />
                            : <div className='immersion__careers_report__chart__no_data'>
                                No campuses found
                            </div>
                        } */}

                        <FilterTable
                            columns={filterTableDataColumns__ProgramsOfStudy}
                            data={filterTableData__ProgramsOfStudy}
                            filters={programsOfStudyFilters}
                            setFilters={setProgramsOfStudyFilters}
                            enableFilters={true}
                        />
                        <div className='immersion__careers_report__chart__row immersion__careers_report__chart__row__vertical'>
                            <ReportDatePicker
                                required={true}
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                            />
                            <div className='immersion__careers_report__chart__row'>
                                <ReportTablet
                                    title={certificateAwardsReport?.total_enrollments?.toString() ?? "0"}
                                    description='Total Enrollments'
                                    color={'green'}
                                />
                                <ReportTablet
                                    title={certificateAwardsReport?.total_courses_completed?.toString() ?? "0"}
                                    description='Total Courses Completed'
                                    color={'green'}
                                />
                                <ReportTablet
                                    title={`${certificateAwardsReport?.completion_rate?.toFixed(1) ?? "0"}%`}
                                    description='Completion Rate'
                                    color={'green'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='immersion__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__CertificateAwardsReport}
                            data={filterTableData__CertificateAwardsReport}
                            filters={[]}
                            setFilters={() => { }}
                            enableFilters={false}
                        />
                        {certificateAwardsReport?.status_chart_data.length ? (
                            <BarChart
                                data={certificateAwardsReport?.status_chart_data ?? []}
                                width={600}
                                height={318}
                                xLabel="Status"
                                yLabel="No. of Certificates Awarded"
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No certificate awards completed
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default CertificateAwardsReport;